<template>
  <div
    class="sidebar-dropdown"
    :class="{ 'dropdown-open': open }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'sidebar-dropdown',
  props: {
    open: {
      type: Boolean,
      default: false
    }
  }
}
</script>
